"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const task_service_1 = require("./task.service");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_task_dto_1 = require("./dto/create-task.dto");
const update_task_dto_1 = require("./dto/update-task.dto");
const task_swagger_1 = require("./task.swagger");
const get_task_dto_1 = require("./dto/get-task.dto");
let TaskController = class TaskController {
    constructor(taskService) {
        this.taskService = taskService;
    }
    async createTask(taskData, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            taskData.createdBy = userId;
            taskData.updatedBy = userId;
            const task = await this.taskService.createTask(taskData);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.taskCreation, task));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskCreationFailed);
        }
    }
    async getTasks(query, res, req) {
        try {
            const { page, limit, search, sort, searchBy, showCompleted } = query;
            const userId = parseInt(req?.headers?.userid);
            const tasks = await this.taskService.getTasks(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sort || "createdAt:DESC", userId, searchBy || "", showCompleted === true);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.taskList, tasks));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskListRetrievalFailed);
        }
    }
    async getTaskById(id, res) {
        try {
            const task = await this.taskService.getTaskById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.taskDetails, task));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskDetailsRetrievalFailed);
        }
    }
    async updateTaskById(id, updateTask, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            updateTask.updatedBy = userId;
            const task = await this.taskService.updateTask(id, updateTask);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.taskUpdation, task));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskUpdateFailed);
        }
    }
    async completeTaskById(id, res) {
        try {
            const task = await this.taskService.completeTask(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.taskCompleted, task));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskCompletionFailed);
        }
    }
    async deleteTaskById(id, res) {
        try {
            await this.taskService.deleteTaskById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.taskDeleted, null));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.taskDeletionFailed);
        }
    }
    async getTasksByOpportunityAndActivity(opportunityId, activityId, res) {
        try {
            const tasks = await this.taskService.getTasksByOpportunityAndActivity(opportunityId, activityId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.tasksFetched, tasks));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.taskNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.failedToFetchTasks);
        }
    }
};
exports.TaskController = TaskController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, task_swagger_1.createTaskSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof create_task_dto_1.CreateTaskDto !== "undefined" && create_task_dto_1.CreateTaskDto) === "function" ? _b : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "createTask", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, task_swagger_1.getTasksSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof get_task_dto_1.GetTasksDto !== "undefined" && get_task_dto_1.GetTasksDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "getTasks", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, task_swagger_1.getTaskByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "getTaskById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, task_swagger_1.updateTaskSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_d = typeof update_task_dto_1.UpdateTaskDto !== "undefined" && update_task_dto_1.UpdateTaskDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "updateTaskById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id/complete"),
    (0, task_swagger_1.completeTaskSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "completeTaskById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, task_swagger_1.deleteTaskSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "deleteTaskById", null);
tslib_1.__decorate([
    (0, common_1.Get)(":opportunityId/:activityId"),
    tslib_1.__param(0, (0, common_1.Param)("opportunityId")),
    tslib_1.__param(1, (0, common_1.Param)("activityId")),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TaskController.prototype, "getTasksByOpportunityAndActivity", null);
exports.TaskController = TaskController = tslib_1.__decorate([
    (0, common_1.Controller)("task"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof task_service_1.TaskService !== "undefined" && task_service_1.TaskService) === "function" ? _a : Object])
], TaskController);
